(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mk-base"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.documentElement;
    if (root.classList.contains('mk-anim')) return;
    root.classList.add('mk-anim');

    var SELECTORS = [
      '.mk-section-head',
      '.mk-reassurance__item',
      '.mk-collections__item',
      '.mk-featured__item',
      '.mk-pillars__item',
      '.mk-story__media',
      '.mk-story__content',
      '.mk-testimonials__item',
      '.mk-editorial__head',
      '.mk-editorial__block',
      '.mk-faq__head',
      '.mk-faq__item',
      '.mk-guarantees__title',
      '.mk-guarantees__item',
      '.mk-final-cta__content'
    ].join(',');

    function init() {
      var items = Array.prototype.slice.call(document.querySelectorAll(SELECTORS));
      if (!items.length) return;

      if (!('IntersectionObserver' in window)) {
        items.forEach(function (el) {
          el.classList.add('mk-reveal', 'mk-inview');
        });
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('mk-inview');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
      );

      items.forEach(function (el) {
        // Décalage en cascade entre éléments frères de même type
        var siblings = el.parentElement
          ? Array.prototype.filter.call(el.parentElement.children, function (child) {
              return child.className === el.className;
            })
          : [el];
        var index = siblings.indexOf(el);
        var delay = Math.min(Math.max(index, 0) * 70, 350);
        el.style.setProperty('--mk-reveal-delay', delay + 'ms');
        el.classList.add('mk-reveal');
        observer.observe(el);
      });
    }

    // Barre de progression sous les carrousels mobiles
    function initCarousels() {
      var tracks = document.querySelectorAll('.mk-featured__grid, .mk-pillars__grid, .mk-testimonials__grid');
      Array.prototype.forEach.call(tracks, function (track) {
        if (track.dataset.mkCarousel) return;
        track.dataset.mkCarousel = '1';

        var bar = document.createElement('div');
        bar.className = 'mk-scrollbar';
        bar.setAttribute('aria-hidden', 'true');
        var thumb = document.createElement('span');
        bar.appendChild(thumb);
        track.parentElement.insertBefore(bar, track.nextSibling);

        function update() {
          var max = track.scrollWidth - track.clientWidth;
          if (max < 8) {
            bar.style.display = 'none';
            return;
          }
          bar.style.display = '';
          var ratio = track.clientWidth / track.scrollWidth;
          var progress = max > 0 ? track.scrollLeft / max : 0;
          thumb.style.width = ratio * 100 + '%';
          thumb.style.transform = 'translateX(' + progress * (100 / ratio - 100) + '%)';
        }

        // Piliers : démarrer centré sur la vignette du milieu
        function centerMiddle() {
          if (!track.classList.contains('mk-pillars__grid')) return;
          if (track.dataset.mkUserScrolled) return;
          if (track.scrollWidth <= track.clientWidth) return;
          var mid = track.children[Math.floor((track.children.length - 1) / 2)];
          if (mid) {
            track.scrollLeft = mid.offsetLeft - (track.clientWidth - mid.offsetWidth) / 2;
          }
        }
        centerMiddle();
        window.addEventListener('load', centerMiddle);
        track.addEventListener('pointerdown', function () {
          track.dataset.mkUserScrolled = '1';
        }, { passive: true, once: true });

        var ticking = false;
        track.addEventListener(
          'scroll',
          function () {
            if (!ticking) {
              ticking = true;
              requestAnimationFrame(function () {
                update();
                ticking = false;
              });
            }
          },
          { passive: true }
        );
        window.addEventListener('resize', update);
        update();
      });
    }

    function boot() {
      init();
      initCarousels();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
